import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import AuthLayout from "@/pages/auth/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) return setError("Password must be at least 8 characters");
    if (pw !== confirm) return setError("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (e) {
      setError(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthLayout title="Invalid link" subtitle="This reset link is missing or invalid.">
        <Link to="/forgot-password" className="text-sm font-semibold text-teal hover:underline">Request a new link</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Choose a new password" subtitle="Set a strong password for your account.">
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="pw">New password</Label>
          <Input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5 h-12" data-testid="reset-password-input" autoFocus />
        </div>
        <div>
          <Label htmlFor="confirm">Confirm password</Label>
          <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-12" data-testid="reset-confirm-input" />
        </div>
        {error && <p className="text-sm text-rose-600">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full h-12 bg-teal hover:bg-teal-700" data-testid="reset-submit-btn">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reset password"}
        </Button>
      </form>
    </AuthLayout>
  );
}
